import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Divider,
  Box,
  Alert,
} from "@mui/material";
import { useServerStatus } from "../api/queries";
import { CenteredSpinner } from "./CenteredSpinner";

export type AboutDialogProps = {
  open: boolean;
  onClose: () => void;
};

const VersionRow = ({ label, value }: { label: string; value: string }) => (
  <Grid container spacing={2} sx={{ mb: 1 }}>
    <Grid size={4}>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
        }}
      >
        {label}
      </Typography>
    </Grid>
    <Grid size={8}>
      <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
        {value}
      </Typography>
    </Grid>
  </Grid>
);

export const AboutDialog = ({ open, onClose }: AboutDialogProps) => {
  const { data: serverStatus, isLoading, isError } = useServerStatus();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>About MyMoney</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Frontend
          </Typography>
          <VersionRow label="Git Ref" value={__APP_VERSION_REF__} />
          <VersionRow label="Commit" value={__APP_VERSION_COMMIT__} />
          <VersionRow label="Build Date" value={__APP_VERSION_DATE__} />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box>
          <Typography variant="h6" gutterBottom>
            Backend
          </Typography>
          {isLoading ? (
            <CenteredSpinner padding={2} size={24} />
          ) : isError ? (
            <Alert severity="error">Failed to load backend version info.</Alert>
          ) : serverStatus ? (
            <>
              <VersionRow label="Git Ref" value={serverStatus.version.gitRef} />
              <VersionRow
                label="Commit"
                value={serverStatus.version.gitCommit}
              />
              <VersionRow
                label="Build Date"
                value={serverStatus.version.buildDate}
              />
            </>
          ) : null}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
